import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebase-config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import scrollToTop from "../utils/scrollToTop";
import {
  faHome,
  faUserMd,
  faChartLine,
  faQuestionCircle,
  faNewspaper,
  faBuilding,
  faShieldAlt,
  faMicroscope,
  faClipboardList,
  faUsers,
  faEnvelope,
  faSignInAlt,
  faTags,
  faDollarSign,
  faSignOutAlt,
  faFileAlt,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import "./SideMenu.css";

const SideMenu = ({ user, onLoginClick }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
    scrollToTop();
  };

  const handlePCPClick = () => {
    navigate("/pcp");
    scrollToTop();
  };

  const handlePerformanceCoachingClick = () => {
    navigate("/pricing");
    scrollToTop();
  };

  const handleFAQClick = () => {
    navigate("/faq");
    scrollToTop();
  };

  const handleNewsClick = () => {
    navigate("/news");
    scrollToTop();
  };

  const handleCorporateClick = () => {
    navigate("/corporate");
    scrollToTop();
  };

  const handlePrivacyClick = () => {
    navigate("/privacy");
    scrollToTop();
  };

  const handleClinicalStudyClick = () => {
    navigate("/clinical-study");
    scrollToTop();
  };

  const handleExampleReportClick = () => {
    navigate("/example-report");
    scrollToTop();
  };

  const handleQuestionnaireClick = () => {
    window.open("/questionnaire", "_blank");
  };

  const handleEpitomeClick = () => {
    window.open("/epitome", "_blank");
  };

  const handlePeopleClick = () => {
    navigate("/people");
    scrollToTop();
  };

  const handleContactClick = () => {
    navigate("/contact");
    scrollToTop();
  };

  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div className="side-menu">
      <ul>
        <li>
          <button
            onClick={handleHomeClick}
            className={location.pathname === "/" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faHome} />
            <span>Home</span>
          </button>
        </li>
        <li>
          <button
            onClick={handlePCPClick}
            className={location.pathname === "/pcp" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faUserMd} />
            <span>Primary Care Physicians/EMRs</span>
          </button>
        </li>
        <li>
          <button
            onClick={handlePerformanceCoachingClick}
            className={location.pathname === "/pricing" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faTags} />
            <span>Pricing</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleClinicalStudyClick}
            className={location.pathname === "/clinical-study" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faMicroscope} />
            <span>Clinical Study</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleExampleReportClick}
            className={location.pathname === "/example-report" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faChartBar} />
            <span>Example Report</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleQuestionnaireClick}
            className={location.pathname === "/questionnaire" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faClipboardList} />
            <span>Questionnaire</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleEpitomeClick}
            className={location.pathname === "/epitome" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faClipboardList} />
            <span>Epitome</span>
          </button>
        </li>
        <li>
          <button
            onClick={handlePeopleClick}
            className={location.pathname === "/people" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faUsers} />
            <span>People</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleFAQClick}
            className={location.pathname === "/faq" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faQuestionCircle} />
            <span>FAQ</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleNewsClick}
            className={location.pathname === "/news" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faNewspaper} />
            <span>News</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleCorporateClick}
            className={location.pathname === "/corporate" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faBuilding} />
            <span>Corporate</span>
          </button>
        </li>
        <li>
          <button
            onClick={handlePrivacyClick}
            className={location.pathname === "/privacy" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>Privacy and Data Collection</span>
          </button>
        </li>
        <li>
          <button
            onClick={handleContactClick}
            className={location.pathname === "/contact" ? "active" : ""}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            <span>Contact</span>
          </button>
        </li>
        {!user ? (
          <li>
            <button onClick={onLoginClick}>
              <FontAwesomeIcon icon={faSignInAlt} />
              <span>Login</span>
            </button>
          </li>
        ) : (
          <li>
            <button onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SideMenu;
